<ng-template #component>
    <div class="tool-wrapper" #toolWrapper>
        <app-tool-inner
            (ringSizeChanged)="updateRingPosition($event)"
            cdkDrag
            [cdkDragFreeDragPosition]="position"
            (cdkDragEnded)="handleDragEnd($event)"
            [cdkDragBoundary]="toolWrapper">
            <app-handle cdkDragHandle>
                <i class="fas fa-arrows-alt"></i>
            </app-handle>
        </app-tool-inner>
    </div>
</ng-template>
